import { render, staticRenderFns } from "./MediaField.dynamic.vue?vue&type=template&id=65c1e4e1&"
import script from "./MediaField.dynamic.vue?vue&type=script&lang=js&"
export * from "./MediaField.dynamic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports